/* eslint-disable eqeqeq */
import { Tooltip, Typography, Box } from '@mui/material';
import { useSnackbar } from "notistack";
import React from 'react'
import { Image } from "src/components";

import OVERDUE from 'src/assets/icons/shippingStatus/overdue.png';
import ON_TIME from 'src/assets/icons/shippingStatus/on_time.png';
import DEADLINE from 'src/assets/icons/shippingStatus/deadline.png';


function ShippingStatusIcon({ status, width, height, style={}, showSeparator = false, isMobile}) {
  const { enqueueSnackbar } = useSnackbar();  
  const information = 
    (status == "overdue") ? 'Atrasado' :
    (status == "on_time") ? 'Conferido no prazo' :
    (status == "deadline") ? 'No limite, aguardando' :
    (status == "on_time_awaiting") ? 'No prazo, aguardando' :
    (status == "done_late") ? 'Conferido com atraso' :
    ""
  ;

  const handleClick = () => {
    if (information) return enqueueSnackbar(`${information}`, { variant: "info" });
  };

  const imageStatus = {
    overdue: OVERDUE,
    on_time: ON_TIME,
    deadline: DEADLINE,
    on_time_awaiting: ON_TIME,
    done_late: OVERDUE
  };
  
  const imageSrc = imageStatus[status] ?? null;

  return (
    (status && status !== 'do_not_apply') && (
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
      }}>
        <Image 
          style={{ width, height, borderRadius: 5, ...style }}
          src={imageSrc} 
          alt={information}
        />
        <Typography sx={{ fontSize: '12px', marginLeft: '2px', whiteSpace: {xs: "normal", sm: "nowrap"} }}>
          {!isMobile ? information : information.split(",")[0]}
        </Typography>
        { showSeparator && (
          <Typography sx={{ fontSize: '12px', marginLeft: '5px' }}>
            |
          </Typography>
        )}
      </Box>
    )
  );
}

export default ShippingStatusIcon;
